import React from 'react';
import { connect } from 'react-redux';
import { getTags } from '../../store/tags/actions';

const withTags = WrappedComponent => {
  const mapStateToProps = state => ({
    tags: state.tags,
  });

  const mapDispatchToProps = dispatch => ({
    getTags: () => dispatch(getTags()),
  });

  const TagsContainer = props => <WrappedComponent {...props} />;

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(TagsContainer);
};

export default withTags;



// WEBPACK FOOTER //
// ./src/containers/Tags/index.js